module.exports = __webpack_public_path__ + "img/D1.acfdef4a.png";